module.exports = __webpack_public_path__ + "img/arrow-l.140bbd35.png";